import React, { PropTypes } from 'react';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { SAVED_SEARCH_WORKFLOW } from '../../../constants/WorkflowConstants';
import MessagingContainer from '../../../containers/shared/Messaging/MessagingContainer';
import WorkflowContainer from '../../../containers/WorkflowContainer';
import SearchProbeContainer from '../../../containers/SearchProbeContainer';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { TextButton } from '@bibliocommons/base-buttons';
import { Generic } from '@bibliocommons/shared-messages';
import BroadenSearchLink from '../BroadenSearchLink';
import DidYouMean from '../DidYouMean';
import RSSButton from '../RSSButton';
import { Heart } from '@bibliocommons/base-icons';
import DidNotFindDropdown from '../DidNotFindDropdown';
import ExternalSearchLink from '../ExternalSearchLink';
import './SearchTitle.scss';

class SearchTitle extends BcReactComponent {

  static renderMessaging({ message, clearMessages }) {
    if (message.get('type') === 'Success') {
      return (
        <Generic message={message} clearMessages={clearMessages} />
      );
    }
    return (
      <FormattedMessage
        id={message.get('id')}
        values={message.get('values')}
        tagName="h1" />
    );
  }

  renderSearchTitle() {
    const { query, title, titleKey, searchType, intl, broadened } = this.props;

    const localizedSearchType = intl.formatMessage({
      id: `Search.searchTypes.${broadened ? 'bkw' : searchType}`
    });
    const localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : null;

    return (
      <h1 key="titleForCurrentSearch" data-test-id="searchTitle" className="search-query">
        { title || localizedTitle || <FormattedMessage id="SearchTitle.typeResultsForQuery" values={{ type: localizedSearchType, query: <strong>{query}</strong> }} /> }
      </h1>
    );
  }


  renderBroadenSearchLink() {
    const { broadened, broadenedSearchType, query, searchType } = this.props;

    return (
      <BroadenSearchLink
        query={query}
        searchType={searchType}
        broadenedSearchType={broadenedSearchType}
        isBroadened={broadened} />
    );
  }

  renderDidYouMean() {
    const { handleDidYouMeanImpression, didYouMeanQuerySuggestion, didYouMeanResultCount, showDidYouMean } = this.props;

    return showDidYouMean && (
      <DidYouMean
        key="did-you-mean"
        handleDidYouMeanImpression={handleDidYouMeanImpression}
        querySuggestion={didYouMeanQuerySuggestion}
        resultCount={didYouMeanResultCount} />
    );
  }

  renderDidNotFindDropdown() {
    const { didNotFindOptions, query, searchType, showExternalSearchLink } = this.props;

    return didNotFindOptions.get('isEnabled') ? (
      <DidNotFindDropdown
        query={query}
        searchType={searchType}
        showExternalSearchLink={showExternalSearchLink}
        didNotFindOptions={didNotFindOptions} />
    ) : (
      <div className="external-search-link">
        <ExternalSearchLink query={query} searchType={searchType} />
      </div>
    );
  }

  renderSavedSearchLink(updateWorkflow) {
    if (!this.context.mobileApp) {
      return (
        <div className="saved-search-link">
          <TextButton
            handleClick={() => updateWorkflow(SAVED_SEARCH_WORKFLOW)}
            className="save-search-link"
            data-test-id="save-search-link">
            <Heart />
            {this.props.intl.formatMessage({ id: 'save_search' })}
          </TextButton>
        </div>
      );
    }

    return null;
  }

  renderModifyLink() {
    const { customEdit, intl, query, searchType } = this.props;
    const searchUrl = `/search?custom_edit=${customEdit}&query=${encodeURIComponent(query)}`;

    if (searchType !== 'bl' || this.context.mobileApp) {
      return null;
    }

    return (
      <a href={searchUrl} className="modify-search-link" data-test-id="modify-search-link">
        {intl.formatMessage({ id: 'form_label_modify_my_search' })}
      </a>
    );
  }

  renderRSSButton() {
    const { rssURL } = this.props;

    if (!this.context.mobileApp) {
      return (
        <span className="rss-button">
          <RSSButton url={rssURL} />
        </span>
      );
    }

    return null;
  }

  render() {
    const { query, title, titleKey, suppress } = this.props;

    return (
      <WorkflowContainer id={this.props.id}>
        {(workflowComponent, workflowActions) => workflowComponent || (
          <div className="row cp-search-title" data-test-id="search-title">
            <div className="col-xs-12 search-title-block" aria-atomic="true">
              <div className="search-term">
                <MessagingContainer id="searchTitle">
                  {SearchTitle.renderMessaging}
                </MessagingContainer>
                {query || title || titleKey ? this.renderSearchTitle() : <noop />}
                { this.renderSavedSearchLink(workflowActions.updateWorkflow) }
                {this.renderRSSButton()}
              </div>
            </div>
            <div className="col-xs-12 search-links">
              {!suppress && query ? this.renderBroadenSearchLink() : null}
              { this.renderModifyLink() }
              { this.renderDidYouMean() }
              { this.renderDidNotFindDropdown() }
              <div className="other-search-tools">
                <SearchProbeContainer />
              </div>
            </div>
          </div>
        )}
      </WorkflowContainer>
    );
  }
}

SearchTitle.propTypes = {
  title: PropTypes.string,
  titleKey: PropTypes.string,
  customEdit: PropTypes.bool,
  suppress: PropTypes.bool,
  intl: intlShape,
  searchType: PropTypes.string,
  query: PropTypes.string,
  broadenedSearchType: PropTypes.string,
  broadenedSearchCount: PropTypes.number,
  broadened: PropTypes.bool,
  didYouMeanResultCount: PropTypes.number,
  didYouMeanQuerySuggestion: PropTypes.string,
  showExternalSearchLink: React.PropTypes.bool,
  rssURL: PropTypes.string,
  didNotFindOptions: ImmutablePropTypes.map,
  showDidYouMean: PropTypes.bool
};

SearchTitle.defaultProps = {
  showDidYouMean: true
};


SearchTitle.contextTypes = {
  mobileApp: PropTypes.bool
};


export default injectIntl(SearchTitle);



// WEBPACK FOOTER //
// ./app/components/search/SearchTitle/SearchTitle.jsx